export default "__VITE_ASSET__CJ36nJYi__"